var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isSightlineAvailable
    ? _c(
        "div",
        {
          staticClass: "payments__instruments_item sightline",
          class: { diss: _vm.disabled },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.go2Sightline()
            }
          }
        },
        [
          _c("span", { staticClass: "piitem-picture" }, [
            _c("img", {
              attrs: {
                src: _vm.mediaServer(
                  "/static/brand-img/" + _vm.brandKey + "/sightline.png"
                ),
                alt: "play+"
              }
            })
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "piitem-text" }, [
            _c("div", { staticClass: "piitem-text-headline" }, [
              _vm._v(_vm._s(_vm.$t("Transaction.Sightline")))
            ]),
            _vm._v(" "),
            _vm.depositType
              ? _c("div", { staticClass: "piitem-text-desc" }, [
                  _vm._v(_vm._s(_vm.$t("Payments.PlayPlus.Desc")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.withdrawType
              ? _c("div", { staticClass: "piitem-text-desc" }, [
                  _vm._v(_vm._s(_vm.$t("Payments.PlayPlus.Desc.Withdraw")))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "piitem-arrow" },
            [_c("v-icon", [_vm._v("chevron_right")])],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e9c3e95c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9c3e95c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/SightlineItem.vue
// module id = null
// module chunks = 